<template>
  <div class="md-layout">
    <md-empty-state
      class="md-accent"
      md-icon="link_off"
      md-label="404"
      md-description="Página no encontrada">
    </md-empty-state>
  </div>
</template>

<script>
import eventBus from '../bus'
  export default {
    name: 'EmptyStateRounded', 
    mounted: function(){
        eventBus.$emit('isLoading', false);
    }
  }
</script>